// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../utils/MPWEB.webp", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("../utils/MPMOVIL.webp", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `
/* src/styles/styles.css */
html, body {
  font-size: 1rem;
  margin: 0;
  padding: 0;
  overflow-x: hidden;
  font-family: 'Comfortaa', sans-serif;
}



.pdfSelect img{
  width: 50%;
}
  
.home-page {
  position: relative;
  width: 100%;
  height: 100vh;
  overflow: hidden;
  display: flex;
  align-items: center;
  justify-content: center;
  

}
.home-page .logo, .local-payment .logo{
  margin: 0.5rem 0 0 20%;
  
}
.prices-list .logo{
  margin: 2rem 0 0 20%;
  width: 60%;
}

.logo{
  width: 50.5%;
  margin: 0;
}

.home{
  margin: 0;
  padding: 0;
  position: relative;
  width: 100%;
  height: 100vh; /* Asegura que la altura cubra toda la pantalla */
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___}); /* Cambia aquí por el camino de la imagen */
  background-size: cover; /* Hace que la imagen cubra toda el área sin distorsión */
  background-position: center; /* Centra la imagen */
  background-repeat: no-repeat; /* Evita que la imagen se repita */
  z-index: 1; /* Para que el contenido esté delante de la imagen */
  overflow: hidden; 
}
  /* Imagen de fondo */
.imgBK {
  position: fixed;
  top: 0;
  right: 0; 
  width: 100vw;
  height: 100vh;
  object-fit: cover;
  z-index: -1; /* Para colocarla detrás del contenido */
  
}

.imgInfo{
  width: 50%;
}

.texto h1{
  font-size: 4vh;
  margin: 2rem 0 0.5rem 0;
  padding: 0;
  text-align: center;
}

.texto h3{
  text-align: center;
  margin: 0.5rem;
  padding: 0;
  font-size: 2.5vh;
  
}
.info{
  display: flex;
  flex-direction: column; /* Centra el contenido en columnas */
  align-items:center; /* Centra horizontalmente los elementos */
  justify-content: justify;
  height: 100vh;
  max-width: 40vw;
  margin: 2vh 0 1vh 10vw;
  
}
.buttonSelect{
  display: flex;
  flex-direction: column; /* Centra el contenido en columnas */
  align-items: center; /* Centra horizontalmente los elementos */
  justify-content: center;
  text-align: center;
  width: 50vw;
  background-color: #fff;
  margin: 2vh 0 0 0;

}
.buttonSelect h2{
  padding: 0.5rem;
  margin: 0;
  font-weight: bold;
  -webkit-text-stroke: 1px black; /* Añade un contorno negro */
  font-size: 3vh;
  
}
.buttonSelect h3{
  padding: 0;
  margin: 0.3rem;
  font-size: 2.5vh;
  
}


table {
  width: 100%;
  border-collapse: separate; /* Permite el uso de border-spacing */
  border-spacing: 0.5rem 0.1rem; /* Espacio horizontal y vertical entre celdas */
  font-size: 1.1rem;
}

th, td {
  padding: 0.1rem 0.1rem; /* Espacio interno de cada celda */
  text-align: left;
}

thead {
  background-color: #f2f2f2; /* Color de fondo para el encabezado */
}

tbody tr:nth-child(even) {
  background-color: #f9f9f9; /* Color de fondo alternado para filas */
}
.prices h2{
  padding: 0;
  margin:0.1rem 2rem;
}
.prices th{
  text-align: left;
  font-weight: bold;
}
h1, h2 {
  color: #333;
  margin-top: 10rem;
}

.email-input-form,
.file-upload{
  display: flex;
  flex-direction: column; /* Centra el contenido en columnas */
  align-items: center; /* Centra horizontalmente los elementos */
  justify-content: center;
  margin: 1rem 1rem 1rem 1rem;
  color: black;
  border: none;
  cursor: pointer;
  text-align: center;
  font-family: 'Comfortaa', sans-serif;
  width: 100%; 
  max-height: 80%;
  
  
}
.print-form{
  display: flex;
  flex-direction: column; /* Centra el contenido en columnas */
  align-items: center; /* Centra horizontalmente los elementos */
  justify-content: center;
  margin: 1rem 1rem 1rem 1rem;
  color: black;
  border: none;
  cursor: pointer;
  text-align: center;
  font-family: 'Comfortaa', sans-serif;
  

}
.email-view-page{
  display: flex;
  flex-direction: column; /* Centra el contenido en columnas */
  align-items: center; /* Centra horizontalmente los elementos */
  justify-content: center;
  text-align: center;

}
.email-view-page .scroll-container {
  max-height: 50rem; /* Ajusta el tamaño máximo según lo necesario */
  overflow-y: auto;  
  display: flex;
  flex-direction: column; /* Centra el contenido en columnas */
  align-items: center; /* Centra horizontalmente los elementos */
  justify-content: center;
  text-align: center;
  font-family: 'Comfortaa', sans-serif;
  width: 55vw;
  height: auto; 
  
  
}
.email-view-page embed{
  min-height:50rem;
  width: 100%;
  display: block;
  }
  .email-view-page img{
  height: auto;
  width: 100%;
  display: block;

  }
  .email-view-page p{
    font-size: 1.5rem;
    background-color: #e8b320;
    border-radius: 1rem;
    width: 20rem;
    padding: 1rem;
    color: white;
  }



.pdf-select-page{
  
  display: flex;
  flex-direction: column; /* Centra el contenido en columnas */
  align-items: center; /* Centra horizontalmente los elementos */
  justify-content: center;
  color: black;
  border: none;
  cursor: pointer;
  text-align: center;
  font-family: 'Comfortaa', sans-serif;
  width: 100%;
  word-wrap: break-word; /* Rompe las palabras largas */
  word-break: break-word; /* Compatible con navegadores móviles */
  overflow-wrap: break-word; /* Asegura que el texto se ajuste */

}
.pdfSelect{
  display: flex;
  flex-direction: column;
  align-items:center;
  height: 100%;

}
.pdfSelect-container{
  display: flex;
  flex-direction: column;
  align-items:center;
  justify-content: center;

}
.pdfSelect-button{
  width: 100%;
}
.pdfSelect-info{
  display: flex;
  flex-direction: row;
  align-items:flex-start;
  width: 100%;
  height: auto;
  margin-top:1rem;
  

}
select {
  appearance: none; /* Elimina el diseño nativo en algunos navegadores */
  -webkit-appearance: none; /* Elimina el diseño nativo en Safari */
  -moz-appearance: none; /* Elimina el diseño nativo en Firefox */
  background-color: white; /* Fondo personalizado */
  
  border: 1px solid black; /* Borde negro */
  padding: 8px; /* Espaciado interno */
  font-size: 16px; /* Tamaño de fuente */
  border-radius: 4px; /* Bordes redondeados */
  color: #333; /* Color del texto */
  cursor: pointer;
  width: 100%;
  
}

/* Estilo para el contenedor del select */
.select-container {
  position: relative;
  width: 100%;
  
}

/* Flecha personalizada usando pseudo-elemento */
.select-container::after {
  content: '▼'; /* Flecha hacia abajo */
  position: absolute;
  right: 1.6rem;
  top: 40%;
  transform: translateY(-50%);
  pointer-events: none; /* Hace clic solo en el select */
  color: black;
  font-size: 0.75rem;

}

.resumen{
  display: flex;
  flex-direction: column;
  align-items:center;
  font-family: 'Comfortaa', sans-serif;
  font-size: 1.7rem;
  max-width: 100%;

}

.resumen-grid {
  display: flex;
  flex-wrap: wrap;
  gap: 0.5rem; /* Espacio entre cada resumenInfo */
  justify-content: center;
  max-width: 100%;
}

.resumenInfo {
  flex-grow: 1;
  flex-shrink: 1;
  flex-basis: calc(30% - 0.5rem); /* Ocupa la mitad del ancho disponible menos el espacio del gap */
  max-width: 100%;
  min-width: 60%
}

.file-info-row p {
  
  margin: 0 !important;
  padding: 0.05rem !important;
  line-height: 1;         
  flex: 1 1;               /* Permite que los párrafos tomen el mismo ancho disponible */
  max-width: 95%;
  
}


.file-info-row {
  display: flex;         /* Establece un contenedor flex para los párrafos dentro de la fila */
  flex-direction: column; /* Mantiene los párrafos en una columna */
  align-items: center;
  justify-content: center;
  margin:0.5rem;   /* Espacio a la derecha de cada fila para separación */
  flex: 1 1;              /* Permite que cada fila tome el mismo ancho disponible */
  border: 1px solid black; /* Borde negro */
  padding: 0.5rem;
  max-width: 100%;
  box-sizing: border-box;
  word-wrap: break-word; /* Rompe las palabras largas */
  word-break: break-word; /* Compatible con navegadores móviles */
  overflow-wrap: break-word; /* Asegura que el texto se ajuste */
}


.darker-text{
  font-weight: 900;
  color:#ea1e2c
}
/*
.payment-page{
  background-image: url('../utils/MPWEB.webp'); 
  background-size: cover; 
  background-position: center; 
  background-repeat: no-repeat; 
  z-index: 1; 
  height: 100vh;

}*/



.payment-page-info{
  display: flex;
  flex-direction: column;
  align-items:center;
  justify-content: space-around;
  width: 100%;
  
  
  
}

.btnInicio {
  width: 100%;

  
}
.qr{
  padding: 1rem;
  display: flex;
  flex-direction: column;
  align-items:center;
  width: 25%;
  
}
.qr img{
  object-fit: contain;
  margin: 0.5rem;
}
.archivos-subidos{
  display: flex;
  flex-direction: column;
  align-items:center;

  margin: 0; /* Elimina cualquier margen alrededor de los elementos */
  padding: 0;
}
.local-payment{
  margin: 0;
  padding: 0;
  position: relative;
  width: 100%;
  height: 100vh; /* Asegura que la altura cubra toda la pantalla */
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___}); /* Cambia aquí por el camino de la imagen */
  background-size: cover; /* Hace que la imagen cubra toda el área sin distorsión */
  background-position: center; /* Centra la imagen */
  background-repeat: no-repeat; /* Evita que la imagen se repita */
  z-index: 1; /* Para que el contenido esté delante de la imagen */
}

.local-payment-info{
  display: flex;
  flex-direction: column;
  align-items:center;
  justify-content: space-around;
  height: auto;
  margin: 15% 0 0 1rem; /* Elimina cualquier margen alrededor de los elementos */
  padding: 0;
  width: 45%;

  
  
  
}
.archivos-subidos div {
  margin: 0; /* Elimina cualquier margen alrededor de los elementos */
  padding: 0; /* Elimina cualquier padding si es necesario */
}
.archivos-subidos p{
  font-family: 'Comfortaa', sans-serif;
  font-size: 1.2rem;
  margin: 0.5rem 0 0.5rem 0; 
  padding: 0;
  text-align: center;
}
.payment-page-info p{
  
  font-size: 1.2rem;
  margin: 0.5rem 4rem 0.5rem 4rem; 
  padding: 0;
  text-align: center;
  
}
  .local-payment-info h2{
  font-family: 'Comfortaa', sans-serif;
  font-size: 1.5rem;
  margin: 0; 
  padding: 0;
  text-align: center;
}
.archivos-subidos h4, .payment-page-info h2 {
  font-family: 'Comfortaa', sans-serif;
  font-size: 1.5rem;
  margin: 0.5rem 0 0.5rem 0; 
  padding: 0;
  text-align: center;
  font-weight: bold;
}
  .payment-page-info h1 {
  font-family: 'Comfortaa', sans-serif;
  font-size: 1.7rem;
  margin: 1rem 0 1rem 0; 
  padding: 1rem;
  text-align: center;
  font-weight: bold;
  background-color: #f1999f;
  color: #fff;
  border: none;
  border-radius: 0.75rem; /* Bordes curvados */
}
.loading-overlay{
  display: flex;
  flex-direction: column;
  align-items:center;
  justify-content: center;
  margin: 2rem 0.5rem 0.5rem 0.5rem;
}
.loading-overlay p {
  font-family: 'Comfortaa', sans-serif;
  font-size: 1.7rem;
  padding: 0.5rem;
  text-align: center;
  font-weight: bold;
  background-color: #f1999f;
  color: #fff;
  border: none;
  border-radius: 0.75rem; /* Bordes curvados */
}



label,span{
  display: flex;
  flex-direction: column; /* Cambia a 'row' si los elementos están en fila */
  align-items: center; 
  font-size: 2.5vh;
  justify-content: center;
  margin-bottom: 0.05rem;
  font-weight: bold;
}

input[type="email"]{
  position: relative;
  display: inline-block;
  margin-top:5rem;
  color: black;
  border: none;
  cursor: pointer;
  text-align: center;
  font-family: 'Comfortaa', sans-serif;
  font-size: 1.2rem;
  border: 1px solid black; /* Borde negro */
  
  
}
select,
input[type="number"],
input[type="email"],
input[type="text"]  {
  width: 100%;
  padding: 0.5rem;
  margin-top: 0.3125rem;
  margin-bottom: 1.25rem;
  font-family: 'Comfortaa', sans-serif;
  font-size: 1.2rem;
  max-width: 100%; /* Limita el ancho máximo al 100% del contenedor */
  box-sizing: border-box; 
  
  
}

.print-form h3{
  margin:0;
  padding: 0;
  
}
.print-form p{
  font-size: 1.1rem;
  color: #555;
}
.pages-selection-ppal{
  border: 1px solid black; /* Borde negro */
  padding: 0.5rem;
  margin: 0.7rem;
}
.pages-selection-ppal h3{
  padding: 0.5rem;
  
}
.pages-selection p{
  color: #555;
  width: 70%;}

.pages-selection{
  display: flex;
  flex-direction: row; /* Centra el contenido en columnas */
  align-items: center; /* Centra horizontalmente los elementos */
  justify-content: center;
}


.specific-pages{
  display: flex;
  flex-direction: row; /* Centra el contenido en columnas */
  align-items:center;
  justify-content:center;
  width: 100%;
  border: 1px solid black; /* Borde negro */
}
.specific-pages-info{
  
  width: 50%;
}
.specific-pages-o{
  margin: 1rem;
  width: 10%;
}
.specific-pages-fromTo{
  display: flex;
  flex-direction: row; /* Centra el contenido en columnas */
  align-items: center; /* Centra horizontalmente los elementos */
  justify-content: center;
  
  
}
.specific-pages-fromTo label{
  margin:0;
  padding: 0;
  
}
.specific-pages-fromTo input[type="number"]{
  width: 60%;
}
.specific-pages-fromTo p{
  margin:0.5rem 0 0.5rem 0;
  padding: 0;
  
}
.individual-pages{
  display: flex;
  flex-direction: column; /* Centra el contenido en columnas */
  align-items: center; /* Centra horizontalmente los elementos */
  justify-content: center;
  text-align: center;
}
.individual-pages-info{
  display: flex;
  flex-direction: row; /* Centra el contenido en columnas */
  align-items: center; /* Centra horizontalmente los elementos */
  justify-content: center;
  width: 100%;
  
}
.individual-pages-info input[type="number"]{
  text-align: center;
  align-items: center; /* Centra horizontalmente los elementos */
  justify-content: center;
  margin-top: 1rem;
  width: auto;
  max-width: 4rem;
}
.individual-pages-info button{
  width: 50%;
  margin: 0.5rem;
}
.selected-pages{
  max-width: 12rem;
}

.print-pages p{
  padding: 0;
  margin: 0;
  max-width: 25rem;
}

input[type="checkbox"]{
  width: 1.563rem;
  height: 1.563rem;
  margin-left: 1rem;
  margin-bottom: 1rem;
}
.highlight-input {
  
  color: #9d9b9b; /* Color del texto */
}

.Buttons{
  display: flex;
  flex-direction: row; /* Centra el contenido en columnas */
  align-items: space-between; /* Centra horizontalmente los elementos */
  justify-content: center;

}


.button {
  padding: 0.625rem 1.25rem;
  background-color: #ea1e2c;
  color: #fff;
  border: none;
  border-radius: 0.75rem; /* Bordes curvados */
  cursor: pointer;
  font-family: 'Comfortaa', sans-serif;
  margin-right: 0.5rem;
  font-size: 1.2rem;
  margin:0.5rem
  
}

.button:hover {
  background-color: #e8b320;
}
.prices-button {
  padding: 0.5rem 0.6rem 0.5rem 0.6rem;
  background-color: #ea1e2c;
  color: #fff;
  border: none;
  border-radius: 1rem; /* Bordes curvados */
  cursor: pointer;
  font-family: 'Comfortaa', sans-serif;
  font-size: 2.5vh;
  margin:0.5rem;       /* Usa el color de texto del contenedor */
  text-decoration: none;   /* Quita el subrayado */

}

.prices-button:hover {
  background-color: #e8b320;
}

.buttonSelected{
  display: flex;
  flex-direction: row; /* Centra el contenido en columnas */
  align-items: space-around; /* Centra horizontalmente los elementos */
  justify-content: center;
}
.button2 {
  padding: 0.4rem 0.5rem;
  background-color: #83cd17;
  color: #fff;
  border: none;
  border-radius: 0.75rem; /* Bordes curvados */
  cursor: pointer;
  font-family: 'Comfortaa', sans-serif;
  margin: 0.5rem;
  font-size: 1.1rem;
  
  
}

.buttonConfirm {
  padding: 0.4rem 0.5rem;
  background-color: #83cd17;
  color: #fff;
  border: none;
  border-radius: 0.75rem; /* Bordes curvados */
  cursor: pointer;
  font-family: 'Comfortaa', sans-serif;
  margin: 0.5rem;
  font-size: 1.1rem;
  width: 30%;
  
}
.buttonEliminar{
  padding: 0.4rem 0.5rem;
  background-color: #ea1e2c;
  color: #fff;
  border: none;
  border-radius: 0.75rem; /* Bordes curvados */
  cursor: pointer;
  font-family: 'Comfortaa', sans-serif;
  margin: 0.5rem;
  font-size: 1.1rem;
  width: 30%;
  
}


.button2:hover {
  background-color: #e8b320;
}

.button3 {
  width: 3rem; /* Ajusta según sea necesario */
  height: 3rem; /* Debe ser igual al width */
  max-width: 3rem;
  max-height: 3rem;
  background-color: #9d9b9b;
  color: #fff;
  border: none;
  border-radius: 50%; /* Hace que el botón sea un círculo */
  cursor: pointer;
  font-family: 'Comfortaa', sans-serif;
  font-size: 1.1rem;
  display: flex; /* Centra el contenido */
  align-items: center; /* Centra verticalmente */
  justify-content: center; /* Centra horizontalmente */
}
.delete-button{

    background-color: #9d9b9b;
    border-radius:0.5rem;
    color: #fff;
    border: none;
    cursor: pointer;
    font-family: 'Comfortaa', sans-serif;
    font-size: 1.1rem;
    display: flex; /* Centra el contenido */
    align-items: center; /* Centra verticalmente */
    justify-content: center; /* Centra horizontalmente */
    margin:1rem;
    padding:0.5rem
}
  
  
  .button3:hover {
    background-color: #e8b320;
  }
  ul {
    list-style-type: none;
    padding: 0;
  }
  
  ul li {
    background-color: #eee;
    margin: 0.313rem 0;
    padding: 0.625rem;
    cursor: pointer;
  }
  
  ul li:hover {
    background-color: #e8b320;
  }
  
  img {
    max-width: 80%;
    height: auto;
    display: inline-block; /* Cambia a inline-block para permitir centrar */
    margin: 0 auto;
}
.image-container img {
  width: 50%;
  max-width: 9rem;
  margin-top: 1rem;
}
.image-container, .image-container p{
  margin: 0;
  padding: 0;
}

.file-upload-container{
  font-family: 'Comfortaa', sans-serif;
  width: 100%;
  border-radius: 4px;
  display: flex;
  flex-direction: column; /* Centra el contenido en columnas */
  align-items:center; 
  justify-content: center;
}
.error-message {
  color: red;
  margin-top: 1.25rem;
  font-size: 1.5rem;
}
.custom-file-upload {
  display: inline-block;
  padding: 8px 12px;
  background-color: #ea1e2c;
  color: white;
  border-radius: 4px;
  cursor: pointer;
}

.custom-file-upload:hover {
  background-color: #e8b320;
}

.custom-file-upload:active {
  background-color: #e8b320;
}

input[type="file"] {
  display: none; /* Oculta el input original */
}

/*Oculta boton de descargar QR en pantallas grandes*/
.download-btn {
  display: none;
  padding: 0.4rem 0.5rem;
  background-color: #83cd17;
  color: #fff;
  border: none;
  border-radius: 0.75rem; /* Bordes curvados */
  cursor: pointer;
  font-family: 'Comfortaa', sans-serif;
  margin: 0.5rem;
  font-size: 1.1rem;
}


.prices-page{
  font-size: 1.2rem;
  margin: 0;
  padding: 0;
  position: relative;
  width: 100%;
  height: 100vh; /* Asegura que la altura cubra toda la pantalla */
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___}); /* Cambia aquí por el camino de la imagen */
  background-size: cover; /* Hace que la imagen cubra toda el área sin distorsión */
  background-position: center; /* Centra la imagen */
  background-repeat: no-repeat; /* Evita que la imagen se repita */
  z-index: 1; /* Para que el contenido esté delante de la imagen */
  display: flex;
  flex-direction: row; /* Centra el contenido en columnas */
  align-items:flex-start; 
  justify-content: flex-start;
}
.prices-list{
  display: flex;
  flex-direction: column; /* Centra el contenido en columnas */
  align-items:flex-start; 
  justify-content: center;
  margin: 0;
  padding: 0;
  width: 70%;
}
.prices-list h1{
  margin: 1.5rem;
  padding: 0;
}
.prices-list-info{
  display: flex;
  flex-direction: column; /* Centra el contenido en columnas */
  align-items: center; 
  justify-content: center;
  margin: 0;
  
  
  
}
.prices-list-info select {
  width: 25rem;
  
}
.prices-list-total{
  margin: 0;
  padding: 0 0 2rem 1rem;
  width: 100%;
  height: 100%;
  font-weight: bold;
  
  
}

.prices-list-total h2{
  margin: 0;
  padding: 0 0 1rem 0;
  text-align: center;
  
}
.prices-list-total p{
  margin: 0 0 0 1rem;
}

.prices-info{
  display: flex;
  flex-direction: row; /* Centra el contenido en columnas */
  align-items: center; 
  justify-content: center;
  margin: 0;
  width: 60%;
  height: 78%;
  
  
    

}




  /* Estilos para pantallas medianas */
  @media (max-width: 1050px) {

    /*
    .payment-page{
      background-image: url('../utils/MPMOVIL.webp'); 
    
    }*/
    .prices-info{
      display: flex;
      flex-direction: column; /* Centra el contenido en columnas */
      align-items: center; 
      justify-content: center;
      margin: 1.5rem 0 0 0;
      width: 100%;
      
          
    
    }
    
    .prices-page{
      display: flex;
      flex-direction: column; /* Centra el contenido en columnas */
      align-items: flex-start; 
      justify-content: center;
      background-image: url(${___CSS_LOADER_URL_REPLACEMENT_1___}); /* Cambia aquí por el camino de la imagen */
      height: 100vh;
      width: 100vw;
 
    }
    .prices-list{
      display: flex;
      flex-direction: column; /* Centra el contenido en columnas */
      align-items: center; 
      justify-content: center;
      width: 100%;
      

    }
    .pdfSelect{
      display: flex;
      flex-direction: column; /* Centra el contenido en columnas */
      align-items: center; 
      justify-content: center;
      
    }
    .pdfSelect-container{
      
      width: 100%;
    }
    
     .local-payment .logo, .prices-list .logo, .pdfSelect .logo, .prices-page .logo{
      margin: 1rem 0 0 0;
      padding: 0;
      width: 80%;
    }
    .home-page .logo {
      margin: 3rem 0 0 0;
      padding: 0;
      width: 80%;
    }
    .prices-page button{
      margin: 0 0 0 0.5rem;
    }
   

    .prices-list h1{
      margin: 2rem;
      padding: 0;
    }
    .prices-list-info{
      display: flex;
      flex-direction: column; /* Centra el contenido en columnas */
      align-items: center; 
      justify-content: center;
      
      min-width: 20rem;

      
      
    }
    .prices-list-info h1{
      font-size: 1.6rem;
      margin: 0 0 1rem 0;
      padding: 0;
      
    }
    .prices-list-info select{
      min-width: 20rem;
      width: 100%;
    }
  
    .prices-list-total{
      margin: 0;
      padding: 0;
      width: 100%;
      height: 100%;
      display: flex;
      flex-direction: column; /* Centra el contenido en columnas */
      align-items: center; 
      justify-content: center; 
      
    }
    .prices-list-info label, .prices-list-info input{
      font-size: 1rem;
 
    }
    .prices-list-info select{
      font-size: 1rem;
    }
    
    .prices-list-total h2{
      padding: 0;
      margin: 0 2rem 1rem 1rem;
      min-width: 15rem;
      font-size: 1.5rem;
      
    }
    .prices-list-total p{
      font-size: 1rem;
      max-width: 14rem;
      margin: 0 0 0.5rem 0;
      background-color: white;
    
    }

    .local-payment{
      display: flex;
      flex-direction: column; /* Centra el contenido en columnas */
      align-items: center; 
      justify-content: center;
      width: 100%;
      

    }
    .local-payment-info{
      width: 90%;
      
    }


    .info{
      max-width: 90vw;
      margin: 3rem 0 0 0;

    }
    .home, .local-payment{
      background-image: url(${___CSS_LOADER_URL_REPLACEMENT_1___}) !important;
      
    }
    .home {
      width: 100%;
      margin: 0;
      padding: 0;
      display: flex;
      flex-direction: column; /* Centra el contenido en columnas */
      align-items: center; 
      justify-content: center;
    }
    .buttonSelect h2, .buttonSelect h3{
      font-size: 1rem;
      width: 20rem;
    }
    .custom-file-upload {
      font-size: 1.2rem;
      margin: 0.5rem;
      width: 15rem;
      padding: 0.5rem 0 0.5rem 0;
    }
    .texto h1{
      font-size: 1.5rem;
    }
    .texto h3{
      font-size: 1rem;
    }
    .pdfSelect{
      display: flex;
      flex-direction: column; /* Centra el contenido en columnas */
      align-items: flex-start; 
      justify-content: center;
      text-align: left;
      height: 100%;
      

    }
    .pdfSelect-info{
      display: flex;
      flex-direction: column; /* Centra el contenido en columnas */
      align-items: center; 
      justify-content: center;
      width: 90%;
      
      
    }
    .pdf-select-page{
      display: flex;
      flex-direction: column; /* Centra el contenido en columnas */
      align-items: center; /* Centra horizontalmente los elementos */
      justify-content: center;
      width: 100%;
      
      
      
    
    }
    .email-view-page .scroll-container {
    
      width: 100%;
      height: auto; 
      max-width: 30rem;
      overflow-y: hidden;  
      
    }
    .email-view-page embed{
      min-height:20rem;
      width: 100%;
      
     }
     /*
     .email-view-page img{
      height: auto;
      width: 100%;
      display: block;
    
     }
    .email-view-page embed, .email-view-page img {
      width: 100vw; 
      height: 50vh; 
    }*/
    .print-form{
      display: flex;
      flex-direction: column; /* Centra el contenido en columnas */
      align-items: center; 
      justify-content: center;
      width: 100%;

      
    }
    .print-form form{
      display: flex;
      flex-direction: column; /* Centra el contenido en columnas */
      align-items: center; 
      justify-content: center;
      

    }
    .print-form label{
      display: flex;
      flex-direction: column; /* Centra el contenido en columnas */
      align-items: center; 
      justify-content: center;
      width:20rem ;
      
    }
    .pages-selection label{
      width: 10rem !important;
    }
    .comentarios{
      margin:1rem 0 0 0;
    }
    .print-form button{
      font-size: 1rem;
    }
    .specific-pages{
      display: flex;
      flex-direction: column; /* Centra el contenido en columnas */
      align-items:center;
      justify-content:center;
      text-align: center;
      width: 100%;
      
    
    }
    .specific-pages-info{
      display: flex;
      flex-direction: column; /* Centra el contenido en columnas */
      align-items: center; /* Centra horizontalmente los elementos */
      justify-content: center;
      width: 100%;
    }
    .specific-pages-info h3{
      padding: 1rem 0 0 0;
      width: 100%;
    }
    .specific-pages-o{
      margin: 0;
      width: 10%;
    }
    .specific-pages-fromTo{
      display: flex;
      flex-direction: row; /* Centra el contenido en columnas */
      align-items: center; /* Centra horizontalmente los elementos */
      justify-content: center;
      width: 10rem;
      
      
    }
    .specific-pages-fromTo label{
      margin:0;
      padding: 0;
      
    }
    .specific-pages-fromTo input[type="number"]{
      width: 60%;
    }
    .specific-pages-fromTo p{
      margin:0.5rem 0 0.5rem 0;
      padding: 0;
      text-align: center;
      
    }
  

    .pages-selection-ppal{
      display: flex;
      flex-direction: column; /* Centra el contenido en columnas */
      align-items: center; 
      justify-content: center;
    
      

    }
    .pages-selection-ppal{
      padding: 0.3rem;
      margin: 0.5rem;
      width: 20rem;
      
    }
    .pages-selection-ppal h3{
      padding: 0;
      width: 100%;
      margin: 0.5rem;
      
      
    }
    .pages-selection p{
      color: #555;
      width: 60%;
    }
    .Buttons{
      display: flex;
      flex-direction: column; /* Centra el contenido en columnas */
      align-items: center; 
      justify-content: center;
    }
    .button{
      font-size: 1rem;
      margin: 0.5rem;
    }
    .loading-overlay{
      width: 90%;
    }
    .loading-overlay p {
      font-size: 1.5rem;

    }

    .qr{
      width: 50%;
      
    }
    .download-btn {
      display: flex;
    }
    .payment-page-info p{
      font-size: 1rem;
    }
    .payment-page-info img, .pdfSelect img{
      margin-top: 0.5rem;
    }
    
  }

    
  
  `, "",{"version":3,"sources":["webpack://./src/styles/styles.css"],"names":[],"mappings":";AACA,0BAA0B;AAC1B;EACE,eAAe;EACf,SAAS;EACT,UAAU;EACV,kBAAkB;EAClB,oCAAoC;AACtC;;;;AAIA;EACE,UAAU;AACZ;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,aAAa;EACb,gBAAgB;EAChB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;;;AAGzB;AACA;EACE,sBAAsB;;AAExB;AACA;EACE,oBAAoB;EACpB,UAAU;AACZ;;AAEA;EACE,YAAY;EACZ,SAAS;AACX;;AAEA;EACE,SAAS;EACT,UAAU;EACV,kBAAkB;EAClB,WAAW;EACX,aAAa,EAAE,iDAAiD;EAChE,yDAA4C,EAAE,2CAA2C;EACzF,sBAAsB,EAAE,yDAAyD;EACjF,2BAA2B,EAAE,qBAAqB;EAClD,4BAA4B,EAAE,kCAAkC;EAChE,UAAU,EAAE,oDAAoD;EAChE,gBAAgB;AAClB;EACE,oBAAoB;AACtB;EACE,eAAe;EACf,MAAM;EACN,QAAQ;EACR,YAAY;EACZ,aAAa;EACb,iBAAiB;EACjB,WAAW,EAAE,wCAAwC;;AAEvD;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,cAAc;EACd,uBAAuB;EACvB,UAAU;EACV,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,cAAc;EACd,UAAU;EACV,gBAAgB;;AAElB;AACA;EACE,aAAa;EACb,sBAAsB,EAAE,oCAAoC;EAC5D,kBAAkB,EAAE,yCAAyC;EAC7D,wBAAwB;EACxB,aAAa;EACb,eAAe;EACf,sBAAsB;;AAExB;AACA;EACE,aAAa;EACb,sBAAsB,EAAE,oCAAoC;EAC5D,mBAAmB,EAAE,yCAAyC;EAC9D,uBAAuB;EACvB,kBAAkB;EAClB,WAAW;EACX,sBAAsB;EACtB,iBAAiB;;AAEnB;AACA;EACE,eAAe;EACf,SAAS;EACT,iBAAiB;EACjB,8BAA8B,EAAE,4BAA4B;EAC5D,cAAc;;AAEhB;AACA;EACE,UAAU;EACV,cAAc;EACd,gBAAgB;;AAElB;;;AAGA;EACE,WAAW;EACX,yBAAyB,EAAE,qCAAqC;EAChE,6BAA6B,EAAE,+CAA+C;EAC9E,iBAAiB;AACnB;;AAEA;EACE,sBAAsB,EAAE,kCAAkC;EAC1D,gBAAgB;AAClB;;AAEA;EACE,yBAAyB,EAAE,sCAAsC;AACnE;;AAEA;EACE,yBAAyB,EAAE,wCAAwC;AACrE;AACA;EACE,UAAU;EACV,kBAAkB;AACpB;AACA;EACE,gBAAgB;EAChB,iBAAiB;AACnB;AACA;EACE,WAAW;EACX,iBAAiB;AACnB;;AAEA;;EAEE,aAAa;EACb,sBAAsB,EAAE,oCAAoC;EAC5D,mBAAmB,EAAE,yCAAyC;EAC9D,uBAAuB;EACvB,2BAA2B;EAC3B,YAAY;EACZ,YAAY;EACZ,eAAe;EACf,kBAAkB;EAClB,oCAAoC;EACpC,WAAW;EACX,eAAe;;;AAGjB;AACA;EACE,aAAa;EACb,sBAAsB,EAAE,oCAAoC;EAC5D,mBAAmB,EAAE,yCAAyC;EAC9D,uBAAuB;EACvB,2BAA2B;EAC3B,YAAY;EACZ,YAAY;EACZ,eAAe;EACf,kBAAkB;EAClB,oCAAoC;;;AAGtC;AACA;EACE,aAAa;EACb,sBAAsB,EAAE,oCAAoC;EAC5D,mBAAmB,EAAE,yCAAyC;EAC9D,uBAAuB;EACvB,kBAAkB;;AAEpB;AACA;EACE,iBAAiB,EAAE,+CAA+C;EAClE,gBAAgB;EAChB,aAAa;EACb,sBAAsB,EAAE,oCAAoC;EAC5D,mBAAmB,EAAE,yCAAyC;EAC9D,uBAAuB;EACvB,kBAAkB;EAClB,oCAAoC;EACpC,WAAW;EACX,YAAY;;;AAGd;AACA;EACE,gBAAgB;EAChB,WAAW;EACX,cAAc;EACd;EACA;EACA,YAAY;EACZ,WAAW;EACX,cAAc;;EAEd;EACA;IACE,iBAAiB;IACjB,yBAAyB;IACzB,mBAAmB;IACnB,YAAY;IACZ,aAAa;IACb,YAAY;EACd;;;;AAIF;;EAEE,aAAa;EACb,sBAAsB,EAAE,oCAAoC;EAC5D,mBAAmB,EAAE,yCAAyC;EAC9D,uBAAuB;EACvB,YAAY;EACZ,YAAY;EACZ,eAAe;EACf,kBAAkB;EAClB,oCAAoC;EACpC,WAAW;EACX,qBAAqB,EAAE,8BAA8B;EACrD,sBAAsB,EAAE,uCAAuC;EAC/D,yBAAyB,EAAE,mCAAmC;;AAEhE;AACA;EACE,aAAa;EACb,sBAAsB;EACtB,kBAAkB;EAClB,YAAY;;AAEd;AACA;EACE,aAAa;EACb,sBAAsB;EACtB,kBAAkB;EAClB,uBAAuB;;AAEzB;AACA;EACE,WAAW;AACb;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,sBAAsB;EACtB,WAAW;EACX,YAAY;EACZ,eAAe;;;AAGjB;AACA;EACE,gBAAgB,EAAE,oDAAoD;EACtE,wBAAwB,EAAE,uCAAuC;EACjE,qBAAqB,EAAE,wCAAwC;EAC/D,uBAAuB,EAAE,wBAAwB;;EAEjD,uBAAuB,EAAE,gBAAgB;EACzC,YAAY,EAAE,sBAAsB;EACpC,eAAe,EAAE,qBAAqB;EACtC,kBAAkB,EAAE,uBAAuB;EAC3C,WAAW,EAAE,oBAAoB;EACjC,eAAe;EACf,WAAW;;AAEb;;AAEA,yCAAyC;AACzC;EACE,kBAAkB;EAClB,WAAW;;AAEb;;AAEA,gDAAgD;AAChD;EACE,YAAY,EAAE,uBAAuB;EACrC,kBAAkB;EAClB,aAAa;EACb,QAAQ;EACR,2BAA2B;EAC3B,oBAAoB,EAAE,gCAAgC;EACtD,YAAY;EACZ,kBAAkB;;AAEpB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,kBAAkB;EAClB,oCAAoC;EACpC,iBAAiB;EACjB,eAAe;;AAEjB;;AAEA;EACE,aAAa;EACb,eAAe;EACf,WAAW,EAAE,mCAAmC;EAChD,uBAAuB;EACvB,eAAe;AACjB;;AAEA;EACE,YAA4B;EAA5B,cAA4B;EAA5B,8BAA4B,EAAE,iEAAiE;EAC/F,eAAe;EACf;AACF;;AAEA;;EAEE,oBAAoB;EACpB,2BAA2B;EAC3B,cAAc;EACd,SAAO,gBAAgB,6DAA6D;EACpF,cAAc;;AAEhB;;;AAGA;EACE,aAAa,UAAU,qEAAqE;EAC5F,sBAAsB,EAAE,yCAAyC;EACjE,mBAAmB;EACnB,uBAAuB;EACvB,aAAa,IAAI,sDAAsD;EACvE,SAAO,eAAe,yDAAyD;EAC/E,uBAAuB,EAAE,gBAAgB;EACzC,eAAe;EACf,eAAe;EACf,sBAAsB;EACtB,qBAAqB,EAAE,8BAA8B;EACrD,sBAAsB,EAAE,uCAAuC;EAC/D,yBAAyB,EAAE,mCAAmC;AAChE;;;AAGA;EACE,gBAAgB;EAChB;AACF;AACA;;;;;;;;;EASE;;;;AAIF;EACE,aAAa;EACb,sBAAsB;EACtB,kBAAkB;EAClB,6BAA6B;EAC7B,WAAW;;;;AAIb;;AAEA;EACE,WAAW;;;AAGb;AACA;EACE,aAAa;EACb,aAAa;EACb,sBAAsB;EACtB,kBAAkB;EAClB,UAAU;;AAEZ;AACA;EACE,mBAAmB;EACnB,cAAc;AAChB;AACA;EACE,aAAa;EACb,sBAAsB;EACtB,kBAAkB;;EAElB,SAAS,EAAE,wDAAwD;EACnE,UAAU;AACZ;AACA;EACE,SAAS;EACT,UAAU;EACV,kBAAkB;EAClB,WAAW;EACX,aAAa,EAAE,iDAAiD;EAChE,yDAA4C,EAAE,2CAA2C;EACzF,sBAAsB,EAAE,yDAAyD;EACjF,2BAA2B,EAAE,qBAAqB;EAClD,4BAA4B,EAAE,kCAAkC;EAChE,UAAU,EAAE,oDAAoD;AAClE;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,kBAAkB;EAClB,6BAA6B;EAC7B,YAAY;EACZ,oBAAoB,EAAE,wDAAwD;EAC9E,UAAU;EACV,UAAU;;;;;AAKZ;AACA;EACE,SAAS,EAAE,wDAAwD;EACnE,UAAU,EAAE,8CAA8C;AAC5D;AACA;EACE,oCAAoC;EACpC,iBAAiB;EACjB,yBAAyB;EACzB,UAAU;EACV,kBAAkB;AACpB;AACA;;EAEE,iBAAiB;EACjB,+BAA+B;EAC/B,UAAU;EACV,kBAAkB;;AAEpB;EACE;EACA,oCAAoC;EACpC,iBAAiB;EACjB,SAAS;EACT,UAAU;EACV,kBAAkB;AACpB;AACA;EACE,oCAAoC;EACpC,iBAAiB;EACjB,yBAAyB;EACzB,UAAU;EACV,kBAAkB;EAClB,iBAAiB;AACnB;EACE;EACA,oCAAoC;EACpC,iBAAiB;EACjB,qBAAqB;EACrB,aAAa;EACb,kBAAkB;EAClB,iBAAiB;EACjB,yBAAyB;EACzB,WAAW;EACX,YAAY;EACZ,sBAAsB,EAAE,oBAAoB;AAC9C;AACA;EACE,aAAa;EACb,sBAAsB;EACtB,kBAAkB;EAClB,uBAAuB;EACvB,iCAAiC;AACnC;AACA;EACE,oCAAoC;EACpC,iBAAiB;EACjB,eAAe;EACf,kBAAkB;EAClB,iBAAiB;EACjB,yBAAyB;EACzB,WAAW;EACX,YAAY;EACZ,sBAAsB,EAAE,oBAAoB;AAC9C;;;;AAIA;EACE,aAAa;EACb,sBAAsB,EAAE,kDAAkD;EAC1E,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;EACvB,sBAAsB;EACtB,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;EAClB,qBAAqB;EACrB,eAAe;EACf,YAAY;EACZ,YAAY;EACZ,eAAe;EACf,kBAAkB;EAClB,oCAAoC;EACpC,iBAAiB;EACjB,uBAAuB,EAAE,gBAAgB;;;AAG3C;AACA;;;;EAIE,WAAW;EACX,eAAe;EACf,qBAAqB;EACrB,sBAAsB;EACtB,oCAAoC;EACpC,iBAAiB;EACjB,eAAe,EAAE,kDAAkD;EACnE,sBAAsB;;;AAGxB;;AAEA;EACE,QAAQ;EACR,UAAU;;AAEZ;AACA;EACE,iBAAiB;EACjB,WAAW;AACb;AACA;EACE,uBAAuB,EAAE,gBAAgB;EACzC,eAAe;EACf,cAAc;AAChB;AACA;EACE,eAAe;;AAEjB;AACA;EACE,WAAW;EACX,UAAU,CAAC;;AAEb;EACE,aAAa;EACb,mBAAmB,EAAE,oCAAoC;EACzD,mBAAmB,EAAE,yCAAyC;EAC9D,uBAAuB;AACzB;;;AAGA;EACE,aAAa;EACb,mBAAmB,EAAE,oCAAoC;EACzD,kBAAkB;EAClB,sBAAsB;EACtB,WAAW;EACX,uBAAuB,EAAE,gBAAgB;AAC3C;AACA;;EAEE,UAAU;AACZ;AACA;EACE,YAAY;EACZ,UAAU;AACZ;AACA;EACE,aAAa;EACb,mBAAmB,EAAE,oCAAoC;EACzD,mBAAmB,EAAE,yCAAyC;EAC9D,uBAAuB;;;AAGzB;AACA;EACE,QAAQ;EACR,UAAU;;AAEZ;AACA;EACE,UAAU;AACZ;AACA;EACE,wBAAwB;EACxB,UAAU;;AAEZ;AACA;EACE,aAAa;EACb,sBAAsB,EAAE,oCAAoC;EAC5D,mBAAmB,EAAE,yCAAyC;EAC9D,uBAAuB;EACvB,kBAAkB;AACpB;AACA;EACE,aAAa;EACb,mBAAmB,EAAE,oCAAoC;EACzD,mBAAmB,EAAE,yCAAyC;EAC9D,uBAAuB;EACvB,WAAW;;AAEb;AACA;EACE,kBAAkB;EAClB,mBAAmB,EAAE,yCAAyC;EAC9D,uBAAuB;EACvB,gBAAgB;EAChB,WAAW;EACX,eAAe;AACjB;AACA;EACE,UAAU;EACV,cAAc;AAChB;AACA;EACE,gBAAgB;AAClB;;AAEA;EACE,UAAU;EACV,SAAS;EACT,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,mBAAmB;AACrB;AACA;;EAEE,cAAc,EAAE,oBAAoB;AACtC;;AAEA;EACE,aAAa;EACb,mBAAmB,EAAE,oCAAoC;EACzD,0BAA0B,EAAE,yCAAyC;EACrE,uBAAuB;;AAEzB;;;AAGA;EACE,yBAAyB;EACzB,yBAAyB;EACzB,WAAW;EACX,YAAY;EACZ,sBAAsB,EAAE,oBAAoB;EAC5C,eAAe;EACf,oCAAoC;EACpC,oBAAoB;EACpB,iBAAiB;EACjB;;AAEF;;AAEA;EACE,yBAAyB;AAC3B;AACA;EACE,oCAAoC;EACpC,yBAAyB;EACzB,WAAW;EACX,YAAY;EACZ,mBAAmB,EAAE,oBAAoB;EACzC,eAAe;EACf,oCAAoC;EACpC,gBAAgB;EAChB,aAAa,QAAQ,yCAAyC;EAC9D,qBAAqB,IAAI,uBAAuB;;AAElD;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,aAAa;EACb,mBAAmB,EAAE,oCAAoC;EACzD,yBAAyB,EAAE,yCAAyC;EACpE,uBAAuB;AACzB;AACA;EACE,sBAAsB;EACtB,yBAAyB;EACzB,WAAW;EACX,YAAY;EACZ,sBAAsB,EAAE,oBAAoB;EAC5C,eAAe;EACf,oCAAoC;EACpC,cAAc;EACd,iBAAiB;;;AAGnB;;AAEA;EACE,sBAAsB;EACtB,yBAAyB;EACzB,WAAW;EACX,YAAY;EACZ,sBAAsB,EAAE,oBAAoB;EAC5C,eAAe;EACf,oCAAoC;EACpC,cAAc;EACd,iBAAiB;EACjB,UAAU;;AAEZ;AACA;EACE,sBAAsB;EACtB,yBAAyB;EACzB,WAAW;EACX,YAAY;EACZ,sBAAsB,EAAE,oBAAoB;EAC5C,eAAe;EACf,oCAAoC;EACpC,cAAc;EACd,iBAAiB;EACjB,UAAU;;AAEZ;;;AAGA;EACE,yBAAyB;AAC3B;;AAEA;EACE,WAAW,EAAE,+BAA+B;EAC5C,YAAY,EAAE,4BAA4B;EAC1C,eAAe;EACf,gBAAgB;EAChB,yBAAyB;EACzB,WAAW;EACX,YAAY;EACZ,kBAAkB,EAAE,qCAAqC;EACzD,eAAe;EACf,oCAAoC;EACpC,iBAAiB;EACjB,aAAa,EAAE,wBAAwB;EACvC,mBAAmB,EAAE,yBAAyB;EAC9C,uBAAuB,EAAE,2BAA2B;AACtD;AACA;;IAEI,yBAAyB;IACzB,oBAAoB;IACpB,WAAW;IACX,YAAY;IACZ,eAAe;IACf,oCAAoC;IACpC,iBAAiB;IACjB,aAAa,EAAE,wBAAwB;IACvC,mBAAmB,EAAE,yBAAyB;IAC9C,uBAAuB,EAAE,2BAA2B;IACpD,WAAW;IACX;AACJ;;;EAGE;IACE,yBAAyB;EAC3B;EACA;IACE,qBAAqB;IACrB,UAAU;EACZ;;EAEA;IACE,sBAAsB;IACtB,kBAAkB;IAClB,iBAAiB;IACjB,eAAe;EACjB;;EAEA;IACE,yBAAyB;EAC3B;;EAEA;IACE,cAAc;IACd,YAAY;IACZ,qBAAqB,EAAE,gDAAgD;IACvE,cAAc;AAClB;AACA;EACE,UAAU;EACV,eAAe;EACf,gBAAgB;AAClB;AACA;EACE,SAAS;EACT,UAAU;AACZ;;AAEA;EACE,oCAAoC;EACpC,WAAW;EACX,kBAAkB;EAClB,aAAa;EACb,sBAAsB,EAAE,oCAAoC;EAC5D,kBAAkB;EAClB,uBAAuB;AACzB;AACA;EACE,UAAU;EACV,mBAAmB;EACnB,iBAAiB;AACnB;AACA;EACE,qBAAqB;EACrB,iBAAiB;EACjB,yBAAyB;EACzB,YAAY;EACZ,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,aAAa,EAAE,6BAA6B;AAC9C;;AAEA,oDAAoD;AACpD;EACE,aAAa;EACb,sBAAsB;EACtB,yBAAyB;EACzB,WAAW;EACX,YAAY;EACZ,sBAAsB,EAAE,oBAAoB;EAC5C,eAAe;EACf,oCAAoC;EACpC,cAAc;EACd,iBAAiB;AACnB;;;AAGA;EACE,iBAAiB;EACjB,SAAS;EACT,UAAU;EACV,kBAAkB;EAClB,WAAW;EACX,aAAa,EAAE,iDAAiD;EAChE,yDAA4C,EAAE,2CAA2C;EACzF,sBAAsB,EAAE,yDAAyD;EACjF,2BAA2B,EAAE,qBAAqB;EAClD,4BAA4B,EAAE,kCAAkC;EAChE,UAAU,EAAE,oDAAoD;EAChE,aAAa;EACb,mBAAmB,EAAE,oCAAoC;EACzD,sBAAsB;EACtB,2BAA2B;AAC7B;AACA;EACE,aAAa;EACb,sBAAsB,EAAE,oCAAoC;EAC5D,sBAAsB;EACtB,uBAAuB;EACvB,SAAS;EACT,UAAU;EACV,UAAU;AACZ;AACA;EACE,cAAc;EACd,UAAU;AACZ;AACA;EACE,aAAa;EACb,sBAAsB,EAAE,oCAAoC;EAC5D,mBAAmB;EACnB,uBAAuB;EACvB,SAAS;;;;AAIX;AACA;EACE,YAAY;;AAEd;AACA;EACE,SAAS;EACT,sBAAsB;EACtB,WAAW;EACX,YAAY;EACZ,iBAAiB;;;AAGnB;;AAEA;EACE,SAAS;EACT,mBAAmB;EACnB,kBAAkB;;AAEpB;AACA;EACE,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,mBAAmB,EAAE,oCAAoC;EACzD,mBAAmB;EACnB,uBAAuB;EACvB,SAAS;EACT,UAAU;EACV,WAAW;;;;;AAKb;;;;;EAKE,oCAAoC;EACpC;;IAEE;;;;MAIE;IACF;MACE,aAAa;MACb,sBAAsB,EAAE,oCAAoC;MAC5D,mBAAmB;MACnB,uBAAuB;MACvB,oBAAoB;MACpB,WAAW;;;;IAIb;;IAEA;MACE,aAAa;MACb,sBAAsB,EAAE,oCAAoC;MAC5D,uBAAuB;MACvB,uBAAuB;MACvB,yDAA8C,EAAE,2CAA2C;MAC3F,aAAa;MACb,YAAY;;IAEd;IACA;MACE,aAAa;MACb,sBAAsB,EAAE,oCAAoC;MAC5D,mBAAmB;MACnB,uBAAuB;MACvB,WAAW;;;IAGb;IACA;MACE,aAAa;MACb,sBAAsB,EAAE,oCAAoC;MAC5D,mBAAmB;MACnB,uBAAuB;;IAEzB;IACA;;MAEE,WAAW;IACb;;KAEC;MACC,kBAAkB;MAClB,UAAU;MACV,UAAU;IACZ;IACA;MACE,kBAAkB;MAClB,UAAU;MACV,UAAU;IACZ;IACA;MACE,oBAAoB;IACtB;;;IAGA;MACE,YAAY;MACZ,UAAU;IACZ;IACA;MACE,aAAa;MACb,sBAAsB,EAAE,oCAAoC;MAC5D,mBAAmB;MACnB,uBAAuB;;MAEvB,gBAAgB;;;;IAIlB;IACA;MACE,iBAAiB;MACjB,kBAAkB;MAClB,UAAU;;IAEZ;IACA;MACE,gBAAgB;MAChB,WAAW;IACb;;IAEA;MACE,SAAS;MACT,UAAU;MACV,WAAW;MACX,YAAY;MACZ,aAAa;MACb,sBAAsB,EAAE,oCAAoC;MAC5D,mBAAmB;MACnB,uBAAuB;;IAEzB;IACA;MACE,eAAe;;IAEjB;IACA;MACE,eAAe;IACjB;;IAEA;MACE,UAAU;MACV,wBAAwB;MACxB,gBAAgB;MAChB,iBAAiB;;IAEnB;IACA;MACE,eAAe;MACf,gBAAgB;MAChB,oBAAoB;MACpB,uBAAuB;;IAEzB;;IAEA;MACE,aAAa;MACb,sBAAsB,EAAE,oCAAoC;MAC5D,mBAAmB;MACnB,uBAAuB;MACvB,WAAW;;;IAGb;IACA;MACE,UAAU;;IAEZ;;;IAGA;MACE,eAAe;MACf,kBAAkB;;IAEpB;IACA;MACE,oEAAyD;;IAE3D;IACA;MACE,WAAW;MACX,SAAS;MACT,UAAU;MACV,aAAa;MACb,sBAAsB,EAAE,oCAAoC;MAC5D,mBAAmB;MACnB,uBAAuB;IACzB;IACA;MACE,eAAe;MACf,YAAY;IACd;IACA;MACE,iBAAiB;MACjB,cAAc;MACd,YAAY;MACZ,0BAA0B;IAC5B;IACA;MACE,iBAAiB;IACnB;IACA;MACE,eAAe;IACjB;IACA;MACE,aAAa;MACb,sBAAsB,EAAE,oCAAoC;MAC5D,uBAAuB;MACvB,uBAAuB;MACvB,gBAAgB;MAChB,YAAY;;;IAGd;IACA;MACE,aAAa;MACb,sBAAsB,EAAE,oCAAoC;MAC5D,mBAAmB;MACnB,uBAAuB;MACvB,UAAU;;;IAGZ;IACA;MACE,aAAa;MACb,sBAAsB,EAAE,oCAAoC;MAC5D,mBAAmB,EAAE,yCAAyC;MAC9D,uBAAuB;MACvB,WAAW;;;;;IAKb;IACA;;MAEE,WAAW;MACX,YAAY;MACZ,gBAAgB;MAChB,kBAAkB;;IAEpB;IACA;MACE,gBAAgB;MAChB,WAAW;;KAEZ;KACA;;;;;;;;;;MAUC;IACF;MACE,aAAa;MACb,sBAAsB,EAAE,oCAAoC;MAC5D,mBAAmB;MACnB,uBAAuB;MACvB,WAAW;;;IAGb;IACA;MACE,aAAa;MACb,sBAAsB,EAAE,oCAAoC;MAC5D,mBAAmB;MACnB,uBAAuB;;;IAGzB;IACA;MACE,aAAa;MACb,sBAAsB,EAAE,oCAAoC;MAC5D,mBAAmB;MACnB,uBAAuB;MACvB,YAAY;;IAEd;IACA;MACE,uBAAuB;IACzB;IACA;MACE,iBAAiB;IACnB;IACA;MACE,eAAe;IACjB;IACA;MACE,aAAa;MACb,sBAAsB,EAAE,oCAAoC;MAC5D,kBAAkB;MAClB,sBAAsB;MACtB,kBAAkB;MAClB,WAAW;;;IAGb;IACA;MACE,aAAa;MACb,sBAAsB,EAAE,oCAAoC;MAC5D,mBAAmB,EAAE,yCAAyC;MAC9D,uBAAuB;MACvB,WAAW;IACb;IACA;MACE,mBAAmB;MACnB,WAAW;IACb;IACA;MACE,SAAS;MACT,UAAU;IACZ;IACA;MACE,aAAa;MACb,mBAAmB,EAAE,oCAAoC;MACzD,mBAAmB,EAAE,yCAAyC;MAC9D,uBAAuB;MACvB,YAAY;;;IAGd;IACA;MACE,QAAQ;MACR,UAAU;;IAEZ;IACA;MACE,UAAU;IACZ;IACA;MACE,wBAAwB;MACxB,UAAU;MACV,kBAAkB;;IAEpB;;;IAGA;MACE,aAAa;MACb,sBAAsB,EAAE,oCAAoC;MAC5D,mBAAmB;MACnB,uBAAuB;;;;IAIzB;IACA;MACE,eAAe;MACf,cAAc;MACd,YAAY;;IAEd;IACA;MACE,UAAU;MACV,WAAW;MACX,cAAc;;;IAGhB;IACA;MACE,WAAW;MACX,UAAU;IACZ;IACA;MACE,aAAa;MACb,sBAAsB,EAAE,oCAAoC;MAC5D,mBAAmB;MACnB,uBAAuB;IACzB;IACA;MACE,eAAe;MACf,cAAc;IAChB;IACA;MACE,UAAU;IACZ;IACA;MACE,iBAAiB;;IAEnB;;IAEA;MACE,UAAU;;IAEZ;IACA;MACE,aAAa;IACf;IACA;MACE,eAAe;IACjB;IACA;MACE,kBAAkB;IACpB;;EAEF","sourcesContent":["\n/* src/styles/styles.css */\nhtml, body {\n  font-size: 1rem;\n  margin: 0;\n  padding: 0;\n  overflow-x: hidden;\n  font-family: 'Comfortaa', sans-serif;\n}\n\n\n\n.pdfSelect img{\n  width: 50%;\n}\n  \n.home-page {\n  position: relative;\n  width: 100%;\n  height: 100vh;\n  overflow: hidden;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  \n\n}\n.home-page .logo, .local-payment .logo{\n  margin: 0.5rem 0 0 20%;\n  \n}\n.prices-list .logo{\n  margin: 2rem 0 0 20%;\n  width: 60%;\n}\n\n.logo{\n  width: 50.5%;\n  margin: 0;\n}\n\n.home{\n  margin: 0;\n  padding: 0;\n  position: relative;\n  width: 100%;\n  height: 100vh; /* Asegura que la altura cubra toda la pantalla */\n  background-image: url('../utils/MPWEB.webp'); /* Cambia aquí por el camino de la imagen */\n  background-size: cover; /* Hace que la imagen cubra toda el área sin distorsión */\n  background-position: center; /* Centra la imagen */\n  background-repeat: no-repeat; /* Evita que la imagen se repita */\n  z-index: 1; /* Para que el contenido esté delante de la imagen */\n  overflow: hidden; \n}\n  /* Imagen de fondo */\n.imgBK {\n  position: fixed;\n  top: 0;\n  right: 0; \n  width: 100vw;\n  height: 100vh;\n  object-fit: cover;\n  z-index: -1; /* Para colocarla detrás del contenido */\n  \n}\n\n.imgInfo{\n  width: 50%;\n}\n\n.texto h1{\n  font-size: 4vh;\n  margin: 2rem 0 0.5rem 0;\n  padding: 0;\n  text-align: center;\n}\n\n.texto h3{\n  text-align: center;\n  margin: 0.5rem;\n  padding: 0;\n  font-size: 2.5vh;\n  \n}\n.info{\n  display: flex;\n  flex-direction: column; /* Centra el contenido en columnas */\n  align-items:center; /* Centra horizontalmente los elementos */\n  justify-content: justify;\n  height: 100vh;\n  max-width: 40vw;\n  margin: 2vh 0 1vh 10vw;\n  \n}\n.buttonSelect{\n  display: flex;\n  flex-direction: column; /* Centra el contenido en columnas */\n  align-items: center; /* Centra horizontalmente los elementos */\n  justify-content: center;\n  text-align: center;\n  width: 50vw;\n  background-color: #fff;\n  margin: 2vh 0 0 0;\n\n}\n.buttonSelect h2{\n  padding: 0.5rem;\n  margin: 0;\n  font-weight: bold;\n  -webkit-text-stroke: 1px black; /* Añade un contorno negro */\n  font-size: 3vh;\n  \n}\n.buttonSelect h3{\n  padding: 0;\n  margin: 0.3rem;\n  font-size: 2.5vh;\n  \n}\n\n\ntable {\n  width: 100%;\n  border-collapse: separate; /* Permite el uso de border-spacing */\n  border-spacing: 0.5rem 0.1rem; /* Espacio horizontal y vertical entre celdas */\n  font-size: 1.1rem;\n}\n\nth, td {\n  padding: 0.1rem 0.1rem; /* Espacio interno de cada celda */\n  text-align: left;\n}\n\nthead {\n  background-color: #f2f2f2; /* Color de fondo para el encabezado */\n}\n\ntbody tr:nth-child(even) {\n  background-color: #f9f9f9; /* Color de fondo alternado para filas */\n}\n.prices h2{\n  padding: 0;\n  margin:0.1rem 2rem;\n}\n.prices th{\n  text-align: left;\n  font-weight: bold;\n}\nh1, h2 {\n  color: #333;\n  margin-top: 10rem;\n}\n\n.email-input-form,\n.file-upload{\n  display: flex;\n  flex-direction: column; /* Centra el contenido en columnas */\n  align-items: center; /* Centra horizontalmente los elementos */\n  justify-content: center;\n  margin: 1rem 1rem 1rem 1rem;\n  color: black;\n  border: none;\n  cursor: pointer;\n  text-align: center;\n  font-family: 'Comfortaa', sans-serif;\n  width: 100%; \n  max-height: 80%;\n  \n  \n}\n.print-form{\n  display: flex;\n  flex-direction: column; /* Centra el contenido en columnas */\n  align-items: center; /* Centra horizontalmente los elementos */\n  justify-content: center;\n  margin: 1rem 1rem 1rem 1rem;\n  color: black;\n  border: none;\n  cursor: pointer;\n  text-align: center;\n  font-family: 'Comfortaa', sans-serif;\n  \n\n}\n.email-view-page{\n  display: flex;\n  flex-direction: column; /* Centra el contenido en columnas */\n  align-items: center; /* Centra horizontalmente los elementos */\n  justify-content: center;\n  text-align: center;\n\n}\n.email-view-page .scroll-container {\n  max-height: 50rem; /* Ajusta el tamaño máximo según lo necesario */\n  overflow-y: auto;  \n  display: flex;\n  flex-direction: column; /* Centra el contenido en columnas */\n  align-items: center; /* Centra horizontalmente los elementos */\n  justify-content: center;\n  text-align: center;\n  font-family: 'Comfortaa', sans-serif;\n  width: 55vw;\n  height: auto; \n  \n  \n}\n.email-view-page embed{\n  min-height:50rem;\n  width: 100%;\n  display: block;\n  }\n  .email-view-page img{\n  height: auto;\n  width: 100%;\n  display: block;\n\n  }\n  .email-view-page p{\n    font-size: 1.5rem;\n    background-color: #e8b320;\n    border-radius: 1rem;\n    width: 20rem;\n    padding: 1rem;\n    color: white;\n  }\n\n\n\n.pdf-select-page{\n  \n  display: flex;\n  flex-direction: column; /* Centra el contenido en columnas */\n  align-items: center; /* Centra horizontalmente los elementos */\n  justify-content: center;\n  color: black;\n  border: none;\n  cursor: pointer;\n  text-align: center;\n  font-family: 'Comfortaa', sans-serif;\n  width: 100%;\n  word-wrap: break-word; /* Rompe las palabras largas */\n  word-break: break-word; /* Compatible con navegadores móviles */\n  overflow-wrap: break-word; /* Asegura que el texto se ajuste */\n\n}\n.pdfSelect{\n  display: flex;\n  flex-direction: column;\n  align-items:center;\n  height: 100%;\n\n}\n.pdfSelect-container{\n  display: flex;\n  flex-direction: column;\n  align-items:center;\n  justify-content: center;\n\n}\n.pdfSelect-button{\n  width: 100%;\n}\n.pdfSelect-info{\n  display: flex;\n  flex-direction: row;\n  align-items:flex-start;\n  width: 100%;\n  height: auto;\n  margin-top:1rem;\n  \n\n}\nselect {\n  appearance: none; /* Elimina el diseño nativo en algunos navegadores */\n  -webkit-appearance: none; /* Elimina el diseño nativo en Safari */\n  -moz-appearance: none; /* Elimina el diseño nativo en Firefox */\n  background-color: white; /* Fondo personalizado */\n  \n  border: 1px solid black; /* Borde negro */\n  padding: 8px; /* Espaciado interno */\n  font-size: 16px; /* Tamaño de fuente */\n  border-radius: 4px; /* Bordes redondeados */\n  color: #333; /* Color del texto */\n  cursor: pointer;\n  width: 100%;\n  \n}\n\n/* Estilo para el contenedor del select */\n.select-container {\n  position: relative;\n  width: 100%;\n  \n}\n\n/* Flecha personalizada usando pseudo-elemento */\n.select-container::after {\n  content: '▼'; /* Flecha hacia abajo */\n  position: absolute;\n  right: 1.6rem;\n  top: 40%;\n  transform: translateY(-50%);\n  pointer-events: none; /* Hace clic solo en el select */\n  color: black;\n  font-size: 0.75rem;\n\n}\n\n.resumen{\n  display: flex;\n  flex-direction: column;\n  align-items:center;\n  font-family: 'Comfortaa', sans-serif;\n  font-size: 1.7rem;\n  max-width: 100%;\n\n}\n\n.resumen-grid {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 0.5rem; /* Espacio entre cada resumenInfo */\n  justify-content: center;\n  max-width: 100%;\n}\n\n.resumenInfo {\n  flex: 1 1 calc(30% - 0.5rem); /* Ocupa la mitad del ancho disponible menos el espacio del gap */\n  max-width: 100%;\n  min-width: 60%\n}\n\n.file-info-row p {\n  \n  margin: 0 !important;\n  padding: 0.05rem !important;\n  line-height: 1;         \n  flex: 1;               /* Permite que los párrafos tomen el mismo ancho disponible */\n  max-width: 95%;\n  \n}\n\n\n.file-info-row {\n  display: flex;         /* Establece un contenedor flex para los párrafos dentro de la fila */\n  flex-direction: column; /* Mantiene los párrafos en una columna */\n  align-items: center;\n  justify-content: center;\n  margin:0.5rem;   /* Espacio a la derecha de cada fila para separación */\n  flex: 1;              /* Permite que cada fila tome el mismo ancho disponible */\n  border: 1px solid black; /* Borde negro */\n  padding: 0.5rem;\n  max-width: 100%;\n  box-sizing: border-box;\n  word-wrap: break-word; /* Rompe las palabras largas */\n  word-break: break-word; /* Compatible con navegadores móviles */\n  overflow-wrap: break-word; /* Asegura que el texto se ajuste */\n}\n\n\n.darker-text{\n  font-weight: 900;\n  color:#ea1e2c\n}\n/*\n.payment-page{\n  background-image: url('../utils/MPWEB.webp'); \n  background-size: cover; \n  background-position: center; \n  background-repeat: no-repeat; \n  z-index: 1; \n  height: 100vh;\n\n}*/\n\n\n\n.payment-page-info{\n  display: flex;\n  flex-direction: column;\n  align-items:center;\n  justify-content: space-around;\n  width: 100%;\n  \n  \n  \n}\n\n.btnInicio {\n  width: 100%;\n\n  \n}\n.qr{\n  padding: 1rem;\n  display: flex;\n  flex-direction: column;\n  align-items:center;\n  width: 25%;\n  \n}\n.qr img{\n  object-fit: contain;\n  margin: 0.5rem;\n}\n.archivos-subidos{\n  display: flex;\n  flex-direction: column;\n  align-items:center;\n\n  margin: 0; /* Elimina cualquier margen alrededor de los elementos */\n  padding: 0;\n}\n.local-payment{\n  margin: 0;\n  padding: 0;\n  position: relative;\n  width: 100%;\n  height: 100vh; /* Asegura que la altura cubra toda la pantalla */\n  background-image: url('../utils/MPWEB.webp'); /* Cambia aquí por el camino de la imagen */\n  background-size: cover; /* Hace que la imagen cubra toda el área sin distorsión */\n  background-position: center; /* Centra la imagen */\n  background-repeat: no-repeat; /* Evita que la imagen se repita */\n  z-index: 1; /* Para que el contenido esté delante de la imagen */\n}\n\n.local-payment-info{\n  display: flex;\n  flex-direction: column;\n  align-items:center;\n  justify-content: space-around;\n  height: auto;\n  margin: 15% 0 0 1rem; /* Elimina cualquier margen alrededor de los elementos */\n  padding: 0;\n  width: 45%;\n\n  \n  \n  \n}\n.archivos-subidos div {\n  margin: 0; /* Elimina cualquier margen alrededor de los elementos */\n  padding: 0; /* Elimina cualquier padding si es necesario */\n}\n.archivos-subidos p{\n  font-family: 'Comfortaa', sans-serif;\n  font-size: 1.2rem;\n  margin: 0.5rem 0 0.5rem 0; \n  padding: 0;\n  text-align: center;\n}\n.payment-page-info p{\n  \n  font-size: 1.2rem;\n  margin: 0.5rem 4rem 0.5rem 4rem; \n  padding: 0;\n  text-align: center;\n  \n}\n  .local-payment-info h2{\n  font-family: 'Comfortaa', sans-serif;\n  font-size: 1.5rem;\n  margin: 0; \n  padding: 0;\n  text-align: center;\n}\n.archivos-subidos h4, .payment-page-info h2 {\n  font-family: 'Comfortaa', sans-serif;\n  font-size: 1.5rem;\n  margin: 0.5rem 0 0.5rem 0; \n  padding: 0;\n  text-align: center;\n  font-weight: bold;\n}\n  .payment-page-info h1 {\n  font-family: 'Comfortaa', sans-serif;\n  font-size: 1.7rem;\n  margin: 1rem 0 1rem 0; \n  padding: 1rem;\n  text-align: center;\n  font-weight: bold;\n  background-color: #f1999f;\n  color: #fff;\n  border: none;\n  border-radius: 0.75rem; /* Bordes curvados */\n}\n.loading-overlay{\n  display: flex;\n  flex-direction: column;\n  align-items:center;\n  justify-content: center;\n  margin: 2rem 0.5rem 0.5rem 0.5rem;\n}\n.loading-overlay p {\n  font-family: 'Comfortaa', sans-serif;\n  font-size: 1.7rem;\n  padding: 0.5rem;\n  text-align: center;\n  font-weight: bold;\n  background-color: #f1999f;\n  color: #fff;\n  border: none;\n  border-radius: 0.75rem; /* Bordes curvados */\n}\n\n\n\nlabel,span{\n  display: flex;\n  flex-direction: column; /* Cambia a 'row' si los elementos están en fila */\n  align-items: center; \n  font-size: 2.5vh;\n  justify-content: center;\n  margin-bottom: 0.05rem;\n  font-weight: bold;\n}\n\ninput[type=\"email\"]{\n  position: relative;\n  display: inline-block;\n  margin-top:5rem;\n  color: black;\n  border: none;\n  cursor: pointer;\n  text-align: center;\n  font-family: 'Comfortaa', sans-serif;\n  font-size: 1.2rem;\n  border: 1px solid black; /* Borde negro */\n  \n  \n}\nselect,\ninput[type=\"number\"],\ninput[type=\"email\"],\ninput[type=\"text\"]  {\n  width: 100%;\n  padding: 0.5rem;\n  margin-top: 0.3125rem;\n  margin-bottom: 1.25rem;\n  font-family: 'Comfortaa', sans-serif;\n  font-size: 1.2rem;\n  max-width: 100%; /* Limita el ancho máximo al 100% del contenedor */\n  box-sizing: border-box; \n  \n  \n}\n\n.print-form h3{\n  margin:0;\n  padding: 0;\n  \n}\n.print-form p{\n  font-size: 1.1rem;\n  color: #555;\n}\n.pages-selection-ppal{\n  border: 1px solid black; /* Borde negro */\n  padding: 0.5rem;\n  margin: 0.7rem;\n}\n.pages-selection-ppal h3{\n  padding: 0.5rem;\n  \n}\n.pages-selection p{\n  color: #555;\n  width: 70%;}\n\n.pages-selection{\n  display: flex;\n  flex-direction: row; /* Centra el contenido en columnas */\n  align-items: center; /* Centra horizontalmente los elementos */\n  justify-content: center;\n}\n\n\n.specific-pages{\n  display: flex;\n  flex-direction: row; /* Centra el contenido en columnas */\n  align-items:center;\n  justify-content:center;\n  width: 100%;\n  border: 1px solid black; /* Borde negro */\n}\n.specific-pages-info{\n  \n  width: 50%;\n}\n.specific-pages-o{\n  margin: 1rem;\n  width: 10%;\n}\n.specific-pages-fromTo{\n  display: flex;\n  flex-direction: row; /* Centra el contenido en columnas */\n  align-items: center; /* Centra horizontalmente los elementos */\n  justify-content: center;\n  \n  \n}\n.specific-pages-fromTo label{\n  margin:0;\n  padding: 0;\n  \n}\n.specific-pages-fromTo input[type=\"number\"]{\n  width: 60%;\n}\n.specific-pages-fromTo p{\n  margin:0.5rem 0 0.5rem 0;\n  padding: 0;\n  \n}\n.individual-pages{\n  display: flex;\n  flex-direction: column; /* Centra el contenido en columnas */\n  align-items: center; /* Centra horizontalmente los elementos */\n  justify-content: center;\n  text-align: center;\n}\n.individual-pages-info{\n  display: flex;\n  flex-direction: row; /* Centra el contenido en columnas */\n  align-items: center; /* Centra horizontalmente los elementos */\n  justify-content: center;\n  width: 100%;\n  \n}\n.individual-pages-info input[type=\"number\"]{\n  text-align: center;\n  align-items: center; /* Centra horizontalmente los elementos */\n  justify-content: center;\n  margin-top: 1rem;\n  width: auto;\n  max-width: 4rem;\n}\n.individual-pages-info button{\n  width: 50%;\n  margin: 0.5rem;\n}\n.selected-pages{\n  max-width: 12rem;\n}\n\n.print-pages p{\n  padding: 0;\n  margin: 0;\n  max-width: 25rem;\n}\n\ninput[type=\"checkbox\"]{\n  width: 1.563rem;\n  height: 1.563rem;\n  margin-left: 1rem;\n  margin-bottom: 1rem;\n}\n.highlight-input {\n  \n  color: #9d9b9b; /* Color del texto */\n}\n\n.Buttons{\n  display: flex;\n  flex-direction: row; /* Centra el contenido en columnas */\n  align-items: space-between; /* Centra horizontalmente los elementos */\n  justify-content: center;\n\n}\n\n\n.button {\n  padding: 0.625rem 1.25rem;\n  background-color: #ea1e2c;\n  color: #fff;\n  border: none;\n  border-radius: 0.75rem; /* Bordes curvados */\n  cursor: pointer;\n  font-family: 'Comfortaa', sans-serif;\n  margin-right: 0.5rem;\n  font-size: 1.2rem;\n  margin:0.5rem\n  \n}\n\n.button:hover {\n  background-color: #e8b320;\n}\n.prices-button {\n  padding: 0.5rem 0.6rem 0.5rem 0.6rem;\n  background-color: #ea1e2c;\n  color: #fff;\n  border: none;\n  border-radius: 1rem; /* Bordes curvados */\n  cursor: pointer;\n  font-family: 'Comfortaa', sans-serif;\n  font-size: 2.5vh;\n  margin:0.5rem;       /* Usa el color de texto del contenedor */\n  text-decoration: none;   /* Quita el subrayado */\n\n}\n\n.prices-button:hover {\n  background-color: #e8b320;\n}\n\n.buttonSelected{\n  display: flex;\n  flex-direction: row; /* Centra el contenido en columnas */\n  align-items: space-around; /* Centra horizontalmente los elementos */\n  justify-content: center;\n}\n.button2 {\n  padding: 0.4rem 0.5rem;\n  background-color: #83cd17;\n  color: #fff;\n  border: none;\n  border-radius: 0.75rem; /* Bordes curvados */\n  cursor: pointer;\n  font-family: 'Comfortaa', sans-serif;\n  margin: 0.5rem;\n  font-size: 1.1rem;\n  \n  \n}\n\n.buttonConfirm {\n  padding: 0.4rem 0.5rem;\n  background-color: #83cd17;\n  color: #fff;\n  border: none;\n  border-radius: 0.75rem; /* Bordes curvados */\n  cursor: pointer;\n  font-family: 'Comfortaa', sans-serif;\n  margin: 0.5rem;\n  font-size: 1.1rem;\n  width: 30%;\n  \n}\n.buttonEliminar{\n  padding: 0.4rem 0.5rem;\n  background-color: #ea1e2c;\n  color: #fff;\n  border: none;\n  border-radius: 0.75rem; /* Bordes curvados */\n  cursor: pointer;\n  font-family: 'Comfortaa', sans-serif;\n  margin: 0.5rem;\n  font-size: 1.1rem;\n  width: 30%;\n  \n}\n\n\n.button2:hover {\n  background-color: #e8b320;\n}\n\n.button3 {\n  width: 3rem; /* Ajusta según sea necesario */\n  height: 3rem; /* Debe ser igual al width */\n  max-width: 3rem;\n  max-height: 3rem;\n  background-color: #9d9b9b;\n  color: #fff;\n  border: none;\n  border-radius: 50%; /* Hace que el botón sea un círculo */\n  cursor: pointer;\n  font-family: 'Comfortaa', sans-serif;\n  font-size: 1.1rem;\n  display: flex; /* Centra el contenido */\n  align-items: center; /* Centra verticalmente */\n  justify-content: center; /* Centra horizontalmente */\n}\n.delete-button{\n\n    background-color: #9d9b9b;\n    border-radius:0.5rem;\n    color: #fff;\n    border: none;\n    cursor: pointer;\n    font-family: 'Comfortaa', sans-serif;\n    font-size: 1.1rem;\n    display: flex; /* Centra el contenido */\n    align-items: center; /* Centra verticalmente */\n    justify-content: center; /* Centra horizontalmente */\n    margin:1rem;\n    padding:0.5rem\n}\n  \n  \n  .button3:hover {\n    background-color: #e8b320;\n  }\n  ul {\n    list-style-type: none;\n    padding: 0;\n  }\n  \n  ul li {\n    background-color: #eee;\n    margin: 0.313rem 0;\n    padding: 0.625rem;\n    cursor: pointer;\n  }\n  \n  ul li:hover {\n    background-color: #e8b320;\n  }\n  \n  img {\n    max-width: 80%;\n    height: auto;\n    display: inline-block; /* Cambia a inline-block para permitir centrar */\n    margin: 0 auto;\n}\n.image-container img {\n  width: 50%;\n  max-width: 9rem;\n  margin-top: 1rem;\n}\n.image-container, .image-container p{\n  margin: 0;\n  padding: 0;\n}\n\n.file-upload-container{\n  font-family: 'Comfortaa', sans-serif;\n  width: 100%;\n  border-radius: 4px;\n  display: flex;\n  flex-direction: column; /* Centra el contenido en columnas */\n  align-items:center; \n  justify-content: center;\n}\n.error-message {\n  color: red;\n  margin-top: 1.25rem;\n  font-size: 1.5rem;\n}\n.custom-file-upload {\n  display: inline-block;\n  padding: 8px 12px;\n  background-color: #ea1e2c;\n  color: white;\n  border-radius: 4px;\n  cursor: pointer;\n}\n\n.custom-file-upload:hover {\n  background-color: #e8b320;\n}\n\n.custom-file-upload:active {\n  background-color: #e8b320;\n}\n\ninput[type=\"file\"] {\n  display: none; /* Oculta el input original */\n}\n\n/*Oculta boton de descargar QR en pantallas grandes*/\n.download-btn {\n  display: none;\n  padding: 0.4rem 0.5rem;\n  background-color: #83cd17;\n  color: #fff;\n  border: none;\n  border-radius: 0.75rem; /* Bordes curvados */\n  cursor: pointer;\n  font-family: 'Comfortaa', sans-serif;\n  margin: 0.5rem;\n  font-size: 1.1rem;\n}\n\n\n.prices-page{\n  font-size: 1.2rem;\n  margin: 0;\n  padding: 0;\n  position: relative;\n  width: 100%;\n  height: 100vh; /* Asegura que la altura cubra toda la pantalla */\n  background-image: url('../utils/MPWEB.webp'); /* Cambia aquí por el camino de la imagen */\n  background-size: cover; /* Hace que la imagen cubra toda el área sin distorsión */\n  background-position: center; /* Centra la imagen */\n  background-repeat: no-repeat; /* Evita que la imagen se repita */\n  z-index: 1; /* Para que el contenido esté delante de la imagen */\n  display: flex;\n  flex-direction: row; /* Centra el contenido en columnas */\n  align-items:flex-start; \n  justify-content: flex-start;\n}\n.prices-list{\n  display: flex;\n  flex-direction: column; /* Centra el contenido en columnas */\n  align-items:flex-start; \n  justify-content: center;\n  margin: 0;\n  padding: 0;\n  width: 70%;\n}\n.prices-list h1{\n  margin: 1.5rem;\n  padding: 0;\n}\n.prices-list-info{\n  display: flex;\n  flex-direction: column; /* Centra el contenido en columnas */\n  align-items: center; \n  justify-content: center;\n  margin: 0;\n  \n  \n  \n}\n.prices-list-info select {\n  width: 25rem;\n  \n}\n.prices-list-total{\n  margin: 0;\n  padding: 0 0 2rem 1rem;\n  width: 100%;\n  height: 100%;\n  font-weight: bold;\n  \n  \n}\n\n.prices-list-total h2{\n  margin: 0;\n  padding: 0 0 1rem 0;\n  text-align: center;\n  \n}\n.prices-list-total p{\n  margin: 0 0 0 1rem;\n}\n\n.prices-info{\n  display: flex;\n  flex-direction: row; /* Centra el contenido en columnas */\n  align-items: center; \n  justify-content: center;\n  margin: 0;\n  width: 60%;\n  height: 78%;\n  \n  \n    \n\n}\n\n\n\n\n  /* Estilos para pantallas medianas */\n  @media (max-width: 1050px) {\n\n    /*\n    .payment-page{\n      background-image: url('../utils/MPMOVIL.webp'); \n    \n    }*/\n    .prices-info{\n      display: flex;\n      flex-direction: column; /* Centra el contenido en columnas */\n      align-items: center; \n      justify-content: center;\n      margin: 1.5rem 0 0 0;\n      width: 100%;\n      \n          \n    \n    }\n    \n    .prices-page{\n      display: flex;\n      flex-direction: column; /* Centra el contenido en columnas */\n      align-items: flex-start; \n      justify-content: center;\n      background-image: url('../utils/MPMOVIL.webp'); /* Cambia aquí por el camino de la imagen */\n      height: 100vh;\n      width: 100vw;\n \n    }\n    .prices-list{\n      display: flex;\n      flex-direction: column; /* Centra el contenido en columnas */\n      align-items: center; \n      justify-content: center;\n      width: 100%;\n      \n\n    }\n    .pdfSelect{\n      display: flex;\n      flex-direction: column; /* Centra el contenido en columnas */\n      align-items: center; \n      justify-content: center;\n      \n    }\n    .pdfSelect-container{\n      \n      width: 100%;\n    }\n    \n     .local-payment .logo, .prices-list .logo, .pdfSelect .logo, .prices-page .logo{\n      margin: 1rem 0 0 0;\n      padding: 0;\n      width: 80%;\n    }\n    .home-page .logo {\n      margin: 3rem 0 0 0;\n      padding: 0;\n      width: 80%;\n    }\n    .prices-page button{\n      margin: 0 0 0 0.5rem;\n    }\n   \n\n    .prices-list h1{\n      margin: 2rem;\n      padding: 0;\n    }\n    .prices-list-info{\n      display: flex;\n      flex-direction: column; /* Centra el contenido en columnas */\n      align-items: center; \n      justify-content: center;\n      \n      min-width: 20rem;\n\n      \n      \n    }\n    .prices-list-info h1{\n      font-size: 1.6rem;\n      margin: 0 0 1rem 0;\n      padding: 0;\n      \n    }\n    .prices-list-info select{\n      min-width: 20rem;\n      width: 100%;\n    }\n  \n    .prices-list-total{\n      margin: 0;\n      padding: 0;\n      width: 100%;\n      height: 100%;\n      display: flex;\n      flex-direction: column; /* Centra el contenido en columnas */\n      align-items: center; \n      justify-content: center; \n      \n    }\n    .prices-list-info label, .prices-list-info input{\n      font-size: 1rem;\n \n    }\n    .prices-list-info select{\n      font-size: 1rem;\n    }\n    \n    .prices-list-total h2{\n      padding: 0;\n      margin: 0 2rem 1rem 1rem;\n      min-width: 15rem;\n      font-size: 1.5rem;\n      \n    }\n    .prices-list-total p{\n      font-size: 1rem;\n      max-width: 14rem;\n      margin: 0 0 0.5rem 0;\n      background-color: white;\n    \n    }\n\n    .local-payment{\n      display: flex;\n      flex-direction: column; /* Centra el contenido en columnas */\n      align-items: center; \n      justify-content: center;\n      width: 100%;\n      \n\n    }\n    .local-payment-info{\n      width: 90%;\n      \n    }\n\n\n    .info{\n      max-width: 90vw;\n      margin: 3rem 0 0 0;\n\n    }\n    .home, .local-payment{\n      background-image: url('../utils/MPMOVIL.webp') !important;\n      \n    }\n    .home {\n      width: 100%;\n      margin: 0;\n      padding: 0;\n      display: flex;\n      flex-direction: column; /* Centra el contenido en columnas */\n      align-items: center; \n      justify-content: center;\n    }\n    .buttonSelect h2, .buttonSelect h3{\n      font-size: 1rem;\n      width: 20rem;\n    }\n    .custom-file-upload {\n      font-size: 1.2rem;\n      margin: 0.5rem;\n      width: 15rem;\n      padding: 0.5rem 0 0.5rem 0;\n    }\n    .texto h1{\n      font-size: 1.5rem;\n    }\n    .texto h3{\n      font-size: 1rem;\n    }\n    .pdfSelect{\n      display: flex;\n      flex-direction: column; /* Centra el contenido en columnas */\n      align-items: flex-start; \n      justify-content: center;\n      text-align: left;\n      height: 100%;\n      \n\n    }\n    .pdfSelect-info{\n      display: flex;\n      flex-direction: column; /* Centra el contenido en columnas */\n      align-items: center; \n      justify-content: center;\n      width: 90%;\n      \n      \n    }\n    .pdf-select-page{\n      display: flex;\n      flex-direction: column; /* Centra el contenido en columnas */\n      align-items: center; /* Centra horizontalmente los elementos */\n      justify-content: center;\n      width: 100%;\n      \n      \n      \n    \n    }\n    .email-view-page .scroll-container {\n    \n      width: 100%;\n      height: auto; \n      max-width: 30rem;\n      overflow-y: hidden;  \n      \n    }\n    .email-view-page embed{\n      min-height:20rem;\n      width: 100%;\n      \n     }\n     /*\n     .email-view-page img{\n      height: auto;\n      width: 100%;\n      display: block;\n    \n     }\n    .email-view-page embed, .email-view-page img {\n      width: 100vw; \n      height: 50vh; \n    }*/\n    .print-form{\n      display: flex;\n      flex-direction: column; /* Centra el contenido en columnas */\n      align-items: center; \n      justify-content: center;\n      width: 100%;\n\n      \n    }\n    .print-form form{\n      display: flex;\n      flex-direction: column; /* Centra el contenido en columnas */\n      align-items: center; \n      justify-content: center;\n      \n\n    }\n    .print-form label{\n      display: flex;\n      flex-direction: column; /* Centra el contenido en columnas */\n      align-items: center; \n      justify-content: center;\n      width:20rem ;\n      \n    }\n    .pages-selection label{\n      width: 10rem !important;\n    }\n    .comentarios{\n      margin:1rem 0 0 0;\n    }\n    .print-form button{\n      font-size: 1rem;\n    }\n    .specific-pages{\n      display: flex;\n      flex-direction: column; /* Centra el contenido en columnas */\n      align-items:center;\n      justify-content:center;\n      text-align: center;\n      width: 100%;\n      \n    \n    }\n    .specific-pages-info{\n      display: flex;\n      flex-direction: column; /* Centra el contenido en columnas */\n      align-items: center; /* Centra horizontalmente los elementos */\n      justify-content: center;\n      width: 100%;\n    }\n    .specific-pages-info h3{\n      padding: 1rem 0 0 0;\n      width: 100%;\n    }\n    .specific-pages-o{\n      margin: 0;\n      width: 10%;\n    }\n    .specific-pages-fromTo{\n      display: flex;\n      flex-direction: row; /* Centra el contenido en columnas */\n      align-items: center; /* Centra horizontalmente los elementos */\n      justify-content: center;\n      width: 10rem;\n      \n      \n    }\n    .specific-pages-fromTo label{\n      margin:0;\n      padding: 0;\n      \n    }\n    .specific-pages-fromTo input[type=\"number\"]{\n      width: 60%;\n    }\n    .specific-pages-fromTo p{\n      margin:0.5rem 0 0.5rem 0;\n      padding: 0;\n      text-align: center;\n      \n    }\n  \n\n    .pages-selection-ppal{\n      display: flex;\n      flex-direction: column; /* Centra el contenido en columnas */\n      align-items: center; \n      justify-content: center;\n    \n      \n\n    }\n    .pages-selection-ppal{\n      padding: 0.3rem;\n      margin: 0.5rem;\n      width: 20rem;\n      \n    }\n    .pages-selection-ppal h3{\n      padding: 0;\n      width: 100%;\n      margin: 0.5rem;\n      \n      \n    }\n    .pages-selection p{\n      color: #555;\n      width: 60%;\n    }\n    .Buttons{\n      display: flex;\n      flex-direction: column; /* Centra el contenido en columnas */\n      align-items: center; \n      justify-content: center;\n    }\n    .button{\n      font-size: 1rem;\n      margin: 0.5rem;\n    }\n    .loading-overlay{\n      width: 90%;\n    }\n    .loading-overlay p {\n      font-size: 1.5rem;\n\n    }\n\n    .qr{\n      width: 50%;\n      \n    }\n    .download-btn {\n      display: flex;\n    }\n    .payment-page-info p{\n      font-size: 1rem;\n    }\n    .payment-page-info img, .pdfSelect img{\n      margin-top: 0.5rem;\n    }\n    \n  }\n\n    \n  \n  "],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
